module.exports = __webpack_public_path__ + "img/cover-dec-pluse.fc69bcdf.png";